import { render } from "./TrafficChannel.vue?vue&type=template&id=a655213a"
import script from "./TrafficChannel.vue?vue&type=script&lang=js"
export * from "./TrafficChannel.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__